module.exports = {
  "country": "UK",
  "artist": "Gina G.",
  "song": "Ooh Ahh... Just a Little Bit",
  "year": "1996",
  "place": "8",
  "spotify": "5KsGeqTJgJMAWuyTZ5WmMn"
};